import { render, staticRenderFns } from "./DownloadInvoices.vue?vue&type=template&id=51824bb0&scoped=true"
import script from "./DownloadInvoices.vue?vue&type=script&lang=js"
export * from "./DownloadInvoices.vue?vue&type=script&lang=js"
import style0 from "./DownloadInvoices.vue?vue&type=style&index=0&id=51824bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51824bb0",
  null
  
)

export default component.exports